<template>
  <el-dialog
    v-model="visible"
    :title="dialogConfig.type ? '新建' : '编辑'"
    width="30%"
  >
    <el-form :model="formData" :rules="rules" ref="ruleRef" label-width="120">
      <el-form-item label="类别名称：" prop="name">
        <el-input
          v-model="formData.name"
          v-no-space
          placeholder="请输入名称"
          :maxlength="20"
        />
      </el-form-item>
      <el-form-item label="类别编号：" prop="number">
        <el-input
          v-model="formData.number"
          placeholder="请输入编号"
          :maxlength="40"
        />
      </el-form-item>
      <el-form-item label="状态：" prop="status">
        <el-switch
          v-model="formData.status"
          :active-value="1"
          :inactive-value="2"
          inline-prompt
          active-text="启用"
          inactive-text="停用"
        />
      </el-form-item>
      <el-form-item label="备注： " prop="remark">
        <el-input
          type="textarea"
          v-model="formData.remark"
          :rows="3"
          show-word-limit
          :maxlength="200"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleCancel()">取消</el-button>
        <el-button
          type="primary"
          @click="handleSUbmit()"
          :disabled="buttonLoading"
        >
          保存
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from "vue";
import {
  insertCategory,
  updateCategory,
  queryCategoryById,
} from "@/api/materiel";
import { ElMessage } from "element-plus";

// 事件传递
const emits = defineEmits(["afterSave"]);

// 弹窗控制
const visible = ref(false);

// 表单ref
const ruleRef = ref(null);

// 保存按钮的loading
const buttonLoading = ref(false);

// 弹窗参数
const dialogConfig = ref({});

// 表单
const formData = reactive({
  id: null,
  name: null,
  number: null,
  status: "1",
  remark: null,
});

// 表单校验
const rules = reactive({
  name: [{ required: true, message: "请输入类别名称", trigger: "blur" }],
  number: [
    { required: true, message: "请输入类别编号", trigger: "blur" },
    {
      pattern: /^[a-zA-Z0-9]+$/,
      message: "只能输入英文和数字",
      trigger: "blur",
    },
  ],
});

// 弹窗保存
const handleSUbmit = () => {
  buttonLoading.value = true;
  ruleRef.value?.validate((valid) => {
    if (valid) {
      if (dialogConfig.value.type) {
        addCategory({
          ...formData,
          status: formData.status.toString(),
        });
      } else {
        editCategory({
          ...formData,
          status: formData.status.toString(),
        });
      }
    } else {
      buttonLoading.value = false;
    }
  });
};

// 点击取消
const handleCancel = () => {
  ruleRef.value?.resetFields();
  visible.value = false;
};

// 弹窗打开
const handleDialogOpen = (config) => {
  dialogConfig.value = { ...config };
  ruleRef.value?.resetFields();
  if (!config.type) {
    getCategoryInfo(config.row.id);
  } else {
    (formData.id = null), (formData.name = null), (formData.number = null);
    (formData.status = 1), (formData.remark = null);
  }
  visible.value = true;
};

// 编辑时，打开弹窗获取数据
const getCategoryInfo = (id) => {
  queryCategoryById(id).then((res) => {
    const result = res.data;
    (formData.id = result.id), (formData.name = result.name);
    formData.number = result.number;
    formData.status = result.status.value * 1;
    formData.remark = result.remark;
  });
};
// 新增数据
const addCategory = (req) => {
  insertCategory(req)
    .then((res) => {
      if (res.code == "2000") {
        ElMessage.success("新增成功");
        emits("afterSave");
        visible.value = false;
      }
    })
    .finally(() => {
      buttonLoading.value = false;
    });
};

// 编辑数据
const editCategory = (req) => {
  updateCategory(req)
    .then((res) => {
      if (res.code == "2000") {
        ElMessage.success("修改成功");
        emits("afterSave");
        visible.value = false;
      }
    })
    .finally(() => {
      buttonLoading.value = false;
    });
};

// 暴露函数
defineExpose({
  handleDialogOpen,
});
</script>

<style lang="scss" scoped></style>
